import { isIOS as getIsIOS } from 'App/Helpers/deviceInfo';

import './styles.scss';

const BackgroundDesktop = ({ desktopClass, isIOS }) => (
    <svg
        viewBox='0 0 1342 893'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
        className={desktopClass}
        preserveAspectRatio='none'>
        {!isIOS && (
            <foreignObject x='0' y='0' width='1342' height='893'>
                <div
                    xmlns='http://www.w3.org/1999/xhtml'
                    className={`cloud-background-desktop-blur ${desktopClass + '-blur'}`}
                />
            </foreignObject>
        )}
        <g filter='url(#filter0_d_desktop)'>
            <path
                d='M30.7507 708.908C35.1218 762.253 51.1056 817.552 59.3326 843.288C62.1949 852.242 72.306 858.631 84.5165 859.389C157.401 863.915 407.131 878.999 497.652 879C587.175 879.001 1034.37 858.121 1144.13 845.567C1255.38 832.844 1305.31 812.571 1309.38 785.429C1331 641.096 1331 493.728 1331 374.299C1331 254.022 1313.04 152.09 1298.13 75.6643C1283.22 -0.761666 1182.58 8.33646 1119.21 8.33646L362.507 8.33648C161.216 8.33649 50.7218 13.4673 30.7507 35.6316C11.3984 57.1091 13.4251 116.931 12.1128 169.509C9.60904 269.823 12.1127 364.991 12.1127 426.86C12.1128 488.728 23.2955 617.925 30.7507 708.908Z'
                fill='url(#paint0_linear_lightning_desktop)'
                fillOpacity='0.6'
                shapeRendering='crispEdges'
            />
        </g>

        <defs>
            <linearGradient
                id='paint0_linear_lightning_desktop'
                x1='671'
                y1='0'
                x2='671'
                y2='893'
                gradientUnits='userSpaceOnUse'>
                <stop offset='0' stopColor='#000000' />
                <stop offset='1' stopColor='#333333' />
            </linearGradient>
            <filter
                id='filter0_d_desktop'
                x='0'
                y='0'
                width='1342'
                height='893'
                filterUnits='userSpaceOnUse'
                colorInterpolationFilters='sRGB'>
                <feFlood floodOpacity='0' result='BackgroundImageFix' />
                <feColorMatrix
                    in='SourceAlpha'
                    type='matrix'
                    values='0 0 0 0 0
                        0 0 0 0 0
                        0 0 0 0 0
                        0 0 0 127 0'
                    result='hardAlpha'
                />
                <feOffset dy='3' />
                <feGaussianBlur stdDeviation='5' />
                <feComposite in2='hardAlpha' operator='out' />
                <feColorMatrix
                    type='matrix'
                    values='0 0 0 0 0.0509804
                        0 0 0 0 0.00784314
                        0 0 0 0 0.00784314
                        0 0 0 0.2 0'
                />
                <feBlend
                    mode='normal'
                    in2='BackgroundImageFix'
                    result='effect1_dropShadow_desktop'
                />
                <feBlend
                    mode='normal'
                    in='SourceGraphic'
                    in2='effect1_dropShadow_desktop'
                    result='shape'
                />
            </filter>

            <clipPath id='desktop_blur_clip_path'>
                <path d='M30.7507 708.908C35.1218 762.253 51.1056 817.552 59.3326 843.288C62.1949 852.242 72.306 858.631 84.5165 859.389C157.401 863.915 407.131 878.999 497.652 879C587.175 879.001 1034.37 858.121 1144.13 845.567C1255.38 832.844 1305.31 812.571 1309.38 785.429C1331 641.096 1331 493.728 1331 374.299C1331 254.022 1313.04 152.09 1298.13 75.6643C1283.22 -0.761666 1182.58 8.33646 1119.21 8.33646L362.507 8.33648C161.216 8.33649 50.7218 13.4673 30.7507 35.6316C11.3984 57.1091 13.4251 116.931 12.1128 169.509C9.60904 269.823 12.1127 364.991 12.1127 426.86C12.1128 488.728 23.2955 617.925 30.7507 708.908Z' />
            </clipPath>
        </defs>
    </svg>
);

const BackgroundMobile = ({ mobileClass, isIOS }) => (
    <svg
        className={mobileClass}
        preserveAspectRatio='none'
        viewBox='0 0 708 976'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'>
        {!isIOS && (
            <foreignObject
                x='6.86778'
                y='4.86778'
                width='694.264'
                height='969.304'>
                <div
                    xmlns='http://www.w3.org/1999/xhtml'
                    className={`cloud-background-mobile-blur ${mobileClass + '-blur'}`}
                />
            </foreignObject>
        )}

        <g filter='url(#filter0_d_6548_13171)'>
            <path
                d='M27.0848 776.262C29.3167 834.2 37.4782 894.261 41.6789 922.213C43.1404 931.938 48.3032 938.877 54.538 939.7C91.7534 944.616 219.267 960.999 265.487 961C311.198 961.001 539.54 938.323 595.584 924.688C652.388 910.869 677.884 888.851 679.96 859.371C691 702.61 691 542.553 691 412.84C691 282.206 681.831 171.498 674.218 88.4908C666.604 5.48388 615.214 15.3654 582.858 15.3654L196.481 15.3655C93.7014 15.3655 37.2822 20.9381 27.0848 45.0109C17.2034 68.3378 18.2383 133.311 17.5682 190.416C16.2898 299.368 17.5682 402.731 17.5682 469.927C17.5682 537.123 23.2782 677.444 27.0848 776.262Z'
                fill='url(#paint0_linear_lightning_mobile)'
                fillOpacity='0.6'
                shapeRendering='crispEdges'
            />
        </g>
        <defs>
            <linearGradient
                id='paint0_linear_lightning_mobile'
                x1='354'
                y1='0'
                x2='354'
                y2='976'
                gradientUnits='userSpaceOnUse'>
                <stop offset='0' stopColor='#000000' />
                <stop offset='1' stopColor='#333333' />
            </linearGradient>
            <filter
                id='filter0_d_6548_13171'
                x='6.86778'
                y='4.86778'
                width='694.264'
                height='969.304'
                filterUnits='userSpaceOnUse'
                colorInterpolationFilters='sRGB'>
                <feFlood floodOpacity='0' result='BackgroundImageFix' />
                <feColorMatrix
                    in='SourceAlpha'
                    type='matrix'
                    values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
                    result='hardAlpha'
                />
                <feOffset dy='3' />
                <feGaussianBlur stdDeviation='5' />
                <feComposite in2='hardAlpha' operator='out' />
                <feColorMatrix
                    type='matrix'
                    values='0 0 0 0 0.0509804 0 0 0 0 0.00784314 0 0 0 0 0.00784314 0 0 0 0.2 0'
                />
                <feBlend
                    mode='normal'
                    in2='BackgroundImageFix'
                    result='effect1_dropShadow_6548_13171'
                />
                <feBlend
                    mode='normal'
                    in='SourceGraphic'
                    in2='effect1_dropShadow_6548_13171'
                    result='shape'
                />
            </filter>
            <clipPath
                id='bgblur_0_6548_13171_clip_path'
                transform='translate(-6.86778 -4.86778)'>
                <path d='M27.0848 776.262C29.3167 834.2 37.4782 894.261 41.6789 922.213C43.1404 931.938 48.3032 938.877 54.538 939.7C91.7534 944.616 219.267 960.999 265.487 961C311.198 961.001 539.54 938.323 595.584 924.688C652.388 910.869 677.884 888.851 679.96 859.371C691 702.61 691 542.553 691 412.84C691 282.206 681.831 171.498 674.218 88.4908C666.604 5.48388 615.214 15.3654 582.858 15.3654L196.481 15.3655C93.7014 15.3655 37.2822 20.9381 27.0848 45.0109C17.2034 68.3378 18.2383 133.311 17.5682 190.416C16.2898 299.368 17.5682 402.731 17.5682 469.927C17.5682 537.123 23.2782 677.444 27.0848 776.262Z' />
            </clipPath>
        </defs>
    </svg>
);

const CloudBackground = ({ desktopClass, mobileClass, minWidth = 1400 }) => {
    const isIOS = getIsIOS();
    const mod = minWidth === 992 ? 'cloud-bg--min-992' : 'cloud-bg--min-1400';

    return (
        <div className={`cloud-bg ${mod}`}>
            <div className='cloud-bg__dsk'>
                <BackgroundDesktop desktopClass={desktopClass} isIOS={isIOS} />
            </div>
            <div className='cloud-bg__mob'>
                <BackgroundMobile mobileClass={mobileClass} isIOS={isIOS} />
            </div>
        </div>
    );
};

export default CloudBackground;
